import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as s } from "react";
import { I as e } from "../../../../IconBase-CxZyIWw2.js";
const i = s((t, a) => /* @__PURE__ */ o.jsx(
  e,
  {
    ref: a,
    ...t,
    image: (r) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "currentColor",
        viewBox: "0 0 16 16",
        ...r,
        children: /* @__PURE__ */ o.jsx("path", { d: "M8 3a5 5 0 0 1 3 9V9H9v5a1 1 0 0 0 1 1h5v-2h-2.101A7 7 0 0 0 8 1zM8 13a5 5 0 0 1-3-9v3h2V2a1 1 0 0 0-1-1H1v2h2.101A7 7 0 0 0 8 15z" })
      }
    )
  }
));
i.displayName = "RotateIcon";
export {
  i as RotateIcon,
  i as default
};
//# sourceMappingURL=index.js.map
